import { render, staticRenderFns } from "./deletemodal.vue?vue&type=template&id=6d8b804a&"
import script from "./deletemodal.vue?vue&type=script&lang=js&"
export * from "./deletemodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports